var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('div',{staticClass:"tab-pane fade",class:{ 'active show': _vm.active },attrs:{"role":"tabpanel","id":_vm.tabId,"aria-hidden":!_vm.active,"aria-labelledby":("step-" + _vm.tabId)}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }